import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toggleModal, updateDescription, updatePrivacy, updateTitle, updateDuonutThumbnails, updateCategory, updateSettings, updateCoverPhoto } from "../../../redux/slices/duonutSettings";
import { toDataUrl } from "../../../utils";
import Dropdown from "../../Dropdown";
import EditDuonutIcon from "../../../assets/icons/edit-duonut.svg";
import "./settings.css";
import { motion, AnimatePresence } from "framer-motion";
import PublishButton from "../../PublishButton/publishButton";

const maxTitleChar = 30;
const maxDescChar = 200;

export default function DuonutSettings() {
  const inputRefFirst = useRef(null);
  const inputRefSecond = useRef(null);
  const inputFileRef = useRef(null);

  const { title, description, isPublic, isPrivate, category } = useSelector((state) => state.duonutSettings.settings);
  const { categories, modalOpen: settingsModalOpen, coverPhoto } = useSelector((state) => state.duonutSettings);
  // console.log(coverPhoto);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  const [initialSettings, setInitialSettings] = useState({ title, description, isPublic, isPrivate, category });

  const handleImageChange = (e) => {
    let cover_photo = {};
    // console.log(e.target.files)
    toDataUrl(e.target.files[0], (res) => {
      let result = res;
      let resData = { name: e.target.files[0].name, uri: result };
      cover_photo = { ...resData };
      dispatch(updateCoverPhoto({ coverPhoto: cover_photo }));
    });
  };

  const handleClose = () => dispatch(toggleModal());

  //exit without save- set back to original initial settings
  const handleExit = () => {
    dispatch(toggleModal());
    dispatch(updateSettings({ settings: initialSettings }));
  };

  const onCategoryChange = (id) => {
    dispatch(updateCategory({ category: id }));
  };
  return (
    <AnimatePresence>
      {settingsModalOpen && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.7, ease: "backOut" }} className="modal_container modal-container-video-upload">
          <motion.div initial={{ y: -20 }} animate={{ y: 0 }} exit={{ y: -30 }} transition={{ duration: 0.7, ease: "backOut" }} className="settings_modal">
            <h4 className="modal_header"> Duonut Settings</h4>
            {error && <p className="settings-error"> Fill all the required fields </p>}
            <div className="row">
              <div className="col-lg-6 column-left">
                <div className="form_fields">
                  <div className="form_field">
                    <label>
                      {" "}
                      <span style={{ color: "red" }}>*</span> Title
                    </label>
                    <input className="title_input" value={title === null ? "" : title} onChange={(e) => (e.target.value.length > maxTitleChar ? null : dispatch(updateTitle(e.target.value)))} />
                  </div>
                  <div className="form_field">
                    <label>
                      {/* <span style={{ color: "red" }}>* </span> */}
                      Short Description
                    </label>
                    <textarea
                      rows="3"
                      className="description_input"
                      value={description === null ? "" : description}
                      onChange={(e) => (e.target.value.length > maxDescChar ? null : dispatch(updateDescription(e.target.value)))}
                    ></textarea>
                  </div>
                  <div className="form_field">
                    <label>Visibility</label>
                    <div className="radio_boxes">
                      <div className="radio_box">
                        {isPublic ? <img src="/assets/icons/circle-selected.svg" /> : <img src="/assets/icons/circle-not-selected.svg" onClick={() => dispatch(updatePrivacy())} />}
                        <input ref={inputRefFirst} type="radio" name="visibility" value="circle-selected" className="visibility_input" defaultChecked />
                        <p>Public</p>
                      </div>
                      <div className="radio_box">
                        {isPrivate ? <img src="/assets/icons/circle-selected.svg" /> : <img src="/assets/icons/circle-not-selected.svg" onClick={() => dispatch(updatePrivacy())} />}

                        <input ref={inputRefSecond} type="radio" name="visibility" value="circle-not-selected" className="visibility_input" />
                        <p>Private</p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="form_field">
                <label>Add Music</label>
                <Dropdown data={musicData} />
              </div> */}
                  <div className="form_field">
                    <label>Category</label>
                    {categories && (
                      //  <Dropdown data={categories} onChange={onCategoryChange} initialSelectedItem={category} />
                      <div className="duonut-categories">
                        <div className="categories-wrapper row">
                          {categories.map((singleCategory, idx) => {
                            return (
                              <div className="duonut-category col-sm-4 col-lg-4 col-md-4" key={singleCategory.id}>
                                <div className="category-input-container">
                                  <input
                                    type="radio"
                                    name="duonut_category"
                                    value={singleCategory.value}
                                    onChange={() => onCategoryChange(singleCategory.id)}
                                    defaultChecked={singleCategory.id === category ? true : false}
                                  />
                                </div>
                                <div className="category-name">{singleCategory.value}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-6 column-right">
                <div className="image_column">
                  <p className="image_title">Cover Image</p>
                  <div className="cover_img_container">
                    <img src={EditDuonutIcon} className="edit-duonut-icon" onClick={() => inputFileRef.current.click()} />
                    {Object.keys(coverPhoto).length > 1 ? <img src={coverPhoto.uri} /> : <img src="/assets/duonut-settings.png" />}
                  </div>

                  <input ref={inputFileRef} type="file" onChange={(e) => handleImageChange(e)} style={{ display: "none" }} accept="image/*" />
                </div>
              </div>
            </div>
            <div className="save-btn-container">
              <button className="btn btn-primary action-btn save-btn" onClick={handleClose}>
                Save
              </button>
              <PublishButton className="btn-primary" setError={setError} />
              {/* <button className="btn btn-primary action-btn"  >
                 Publish
              </button> */}
            </div>
            <div className="close-icon icon-button" onClick={handleExit}>
              <img src="/assets/icons/close.svg" />
            </div>
          </motion.div>
          <div className="modal-overlay"></div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
